import {
  deriveScreenId,
  getResolvedScreenConfig,
  resolveFormForSave,
} from "../state/utils/configUtils";

/** Session-only flag: branch switch UI in header (production rollout gate). Default: off. */
const BRANCH_SWITCH_UI_SESSION_KEY = "garage360_branch_switch_ui_enabled";

export function getBranchSwitchUiEnabled(): boolean {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return false;
  }
  return sessionStorage.getItem(BRANCH_SWITCH_UI_SESSION_KEY) === "true";
}

export function setBranchSwitchUiEnabledSession(enabled: boolean): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.setItem(BRANCH_SWITCH_UI_SESSION_KEY, enabled ? "true" : "false");
}

/**
 * True when the current view is an add/edit form screen (not Home or a summary list).
 * Used so branch switches leave form context before reload restores persisted navigation.
 */
export function isAddOrEditScreen(
  currentView: string | undefined | null,
  editModeByScreen?: Record<
    string,
    { isEditMode?: boolean } | undefined
  >
): boolean {
  if (!currentView || currentView === "dashboard" || currentView === "home") {
    return false;
  }

  const screenId = deriveScreenId(currentView) || currentView;
  if (editModeByScreen?.[screenId]?.isEditMode) {
    return true;
  }

  const { formComponent } = resolveFormForSave(
    getResolvedScreenConfig(screenId),
    screenId
  );
  return Boolean(formComponent);
}

/** Screen id to clear when leaving an add/edit view on branch switch. */
export function resolveScreenIdForView(currentView: string): string {
  return deriveScreenId(currentView) || currentView;
}
